__turbopack_context__.v({
  "caret": "select-module__CpdUNG__caret",
  "check": "select-module__CpdUNG__check",
  "menu": "select-module__CpdUNG__menu",
  "optDesc": "select-module__CpdUNG__optDesc",
  "optHint": "select-module__CpdUNG__optHint",
  "optLabel": "select-module__CpdUNG__optLabel",
  "optText": "select-module__CpdUNG__optText",
  "option": "select-module__CpdUNG__option",
  "trigger": "select-module__CpdUNG__trigger",
  "value": "select-module__CpdUNG__value",
  "wrap": "select-module__CpdUNG__wrap",
});
